import { Stack } from '@mui/material'
import { FormHeader } from '@workwave-tidal/core/form'
import { useState } from 'react'

import { PreviewTabs } from '../../../preview/BulkPreview/components/Header/components/PreviewTabs'

import { useTexts } from './useTexts'

type Props = {
  ordersCount: number
}

export function Header(props: Props) {
  const { ordersCount } = props

  const texts = useTexts()
  const [tab, setTab] = useState(0)

  return (
    <Stack direction="column" width="100%" sx={{ paddingX: 3, paddingY: 2 }}>
      <FormHeader title={texts.bulkOrderHeaderTitle(ordersCount)} subtitle={null} />
      <PreviewTabs tab={tab} setTab={setTab} />
    </Stack>
  )
}
